export default __webpack_public_path__ + "static/img1-e9c13596502ede955a24c75d86b06591.png";